import React, { useEffect, useState } from "react";
import FullCircleChart from "./FullCircleChart";

const AvailabilityV2 = (props) => {
  const { availabilityDetails } = props;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, [availabilityDetails]);

  return (
    <>
      <div className="fw-medium mb-2">Available Hours / Week</div>
      {!isLoading ? (
        <div className="d-flex justify-content-center">
          <FullCircleChart
            value={parseInt(availabilityDetails?.availability)}
            size={90}
          />
        </div>
      ) : null}
    </>
  );
};

export default AvailabilityV2;
